const env = import.meta.env;

const config = {
  apiGateway: {
    REGION: env.VITE_API_REGION ?? "eu-west-2",
    URL: env.VITE_API_URL ?? "https://api.datastar.software/v1"
  },
  cognito: {
    REGION: env.VITE_COGNITO_REGION ?? "eu-west-2",
    USER_POOL_ID: env.VITE_COGNITO_USER_POOL_ID ?? "",
    IDENTITY_POOL_ID: env.VITE_COGNITO_IDENTITY_POOL_ID ?? "",
    APP_CLIENT_ID: env.VITE_COGNITO_APP_CLIENT_ID ?? ""
  },
  appVersion: env.VITE_APP_VERSION ?? "dev"
};

export default config;
